if (typeof window.ProductCompare === 'undefined') {
window.ProductCompare = class ProductCompare {
  constructor() {
    this.compareProducts = [];
    this.maxCompareProducts = 5;
    this.storageKey = 'shopify_compare_products';
    this.toggleStateKey = 'shopify_compare_toggle_state';
    
    this.translations = window.productCompareTranslations || {
      maxProductsAlert: 'You can compare maximum 5 products.',
      minProductsAlert: 'Select at least 2 products to compare.',
      compareCount: 'Compare',
      clearAll: 'Clear All',
      compare: 'Compare',
      productComparison: 'Product Comparison',
      viewDetails: 'View Details',
      price: 'Price',
      vendor: 'Vendor',
      type: 'Type',
      description: 'Description',
      variants: 'Variants',
      availability: 'Availability',
      inStock: 'In Stock',
      outOfStock: 'Out of Stock',
      currencySymbol: '$',
      moneyFormat: '${{amount}}',
      moneyWithCurrencyFormat: '${{amount}} USD'
    };
    
    this.init();
  }

  init() {
    this.loadFromStorage();
    this.createCompareBar();
    this.createCompareModal();
    this.bindEvents();
    this.restoreToggleState();
    this.updateUI();
    this.syncCheckboxes();
  }

  formatMoney(price, format) {
    if (typeof price === 'string' && (price.includes('kr') || price.includes('$') || price.includes('€') || price.includes('£') || /[a-zA-Z]/.test(price))) {
      return price;
    }
    
    if (typeof price === 'string') {
      price = price.replace(/[^\d.-]/g, '');
      price = parseFloat(price);
    }
    
    const moneyFormat = format || this.translations.moneyFormat || '${{amount}}';
    
    if (typeof price !== 'number' || isNaN(price)) {
      return 'N/A';
    }

    const value = price.toFixed(2);
    
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.floor(price))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','));
  }

  getFormattedPrice(price, originalPrice = null) {
    if (!price || price === '' || price === '0' || price === 'N/A') {
      return 'N/A';
    }

    let formattedPrice = price;
    if (typeof price === 'string' && (price.includes('kr') || price.includes('$') || price.includes('€') || price.includes('£'))) {
      formattedPrice = price;
    } else {
      formattedPrice = this.formatMoney(price);
    }
    
    if (originalPrice && originalPrice !== '' && originalPrice !== price && originalPrice !== '0') {
      let formattedOriginalPrice = originalPrice;
      if (typeof originalPrice === 'string' && (originalPrice.includes('kr') || originalPrice.includes('$') || originalPrice.includes('€') || originalPrice.includes('£'))) {
        formattedOriginalPrice = originalPrice;
      } else {
        formattedOriginalPrice = this.formatMoney(originalPrice);
      }
      return `<span class="price-current">${formattedPrice}</span><span class="price-original">${formattedOriginalPrice}</span>`;
    }
    
    return `<span class="price-current">${formattedPrice}</span>`;
  }

  createCompareBar() {
    if (document.getElementById('compareBar')) {
      return;
    }

    const compareBar = document.createElement('div');
    compareBar.id = 'compareBar';
    compareBar.className = 'compare-bar';
    compareBar.innerHTML = `
    <div class="container compare-bar-inner">
      <div class="compare-products-preview" id="comparePreview"></div>
      <div class="compare-actions">
        <span id="compareCount">${this.translations.compareCount} (0/${this.maxCompareProducts})</span>
        <button class="clear-all-btn button button--small" id="clearAll">${this.translations.clearAll}</button>
        <button class="compare-btn button button--small" id="compareBtn">${this.translations.compare}</button>
      </div>
    </div>
    `;
    document.body.appendChild(compareBar);
  }

  createCompareModal() {
    if (document.getElementById('compareModal')) {
      return;
    }

    const modal = document.createElement('div');
    modal.id = 'compareModal';
    modal.className = 'compare-modal';
    modal.innerHTML = `
      <div class="compare-modal-content">
        <div class="compare-modal-header">
          <h3 class="h5">${this.translations.productComparison}</h3>
          <button class="compare-modal-close" id="closeModal">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
          </button>
        </div>
        <div class="compare-table-container">
          <table class="compare-table" id="compareTable"></table>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
  }

  // Add this method to your ProductCompare class
bindKeyboardEvents() {
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' || e.keyCode === 27) {
      const modal = document.getElementById('compareModal');
      if (modal && modal.classList.contains('active')) {
        this.hideCompareModal();
      }
    }
  });
}

// Update your existing bindEvents() method to include the keyboard events
bindEvents() {
  const desktopToggle = document.getElementById('compareToggleDesktop');
  const mobileToggle = document.getElementById('compareToggleMobile');
  
  if (desktopToggle) {
    desktopToggle.addEventListener('change', (e) => {
      this.toggleCompareMode(e.target.checked);
      this.saveToggleState(e.target.checked);
      this.syncToggleStates(e.target.checked);
    });
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('change', (e) => {
      this.toggleCompareMode(e.target.checked);
      this.saveToggleState(e.target.checked);
      this.syncToggleStates(e.target.checked);
    });
  }

  document.addEventListener('change', (e) => {
    if (e.target.classList.contains('compare-product')) {
      this.handleProductSelection(e.target);
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.id === 'compareBtn') {
      this.showCompareModal();
    } else if (e.target.id === 'clearAll') {
      this.clearAll();
    } else if (e.target.id === 'closeModal' || e.target.closest('#closeModal')) {
      this.hideCompareModal();
    } else if (e.target.classList.contains('remove-btn') || e.target.closest('.remove-btn')) {
      const removeBtn = e.target.classList.contains('remove-btn') ? e.target : e.target.closest('.remove-btn');
      const productId = removeBtn.getAttribute('data-product-id');
      this.removeProduct(productId);
    } else if (e.target.classList.contains('compare-modal-remove-btn') || e.target.closest('.compare-modal-remove-btn')) {
      const removeBtn = e.target.classList.contains('compare-modal-remove-btn') ? e.target : e.target.closest('.compare-modal-remove-btn');
      const productId = removeBtn.getAttribute('data-product-id');
      this.removeProductFromModal(productId);
    } else if (e.target.id === 'compareModal') {
      this.hideCompareModal();
    }
  });

  // Add keyboard event bindings
  this.bindKeyboardEvents();
  
  this.setupAjaxListeners();
}

  setupAjaxListeners() {
    document.addEventListener('submit', (e) => {
      if (e.target.id === 'FacetSortForm' || e.target.closest('.facets')) {
        setTimeout(() => {
          this.syncCheckboxes();
        }, 500);
      }
    });

    document.addEventListener('click', (e) => {
      if (e.target.closest('facet-remove') || e.target.closest('.active-facets__button')) {
        setTimeout(() => {
          this.syncCheckboxes();
        }, 500);
      }
    });

    document.addEventListener('click', (e) => {
      if (e.target.closest('.pagination') || e.target.closest('[data-pagination]')) {
        setTimeout(() => {
          this.syncCheckboxes();
        }, 500);
      }
    });

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          const hasNewProducts = Array.from(mutation.addedNodes).some(node => 
            node.nodeType === 1 && (
              node.querySelector?.('.compare-product') || 
              node.classList?.contains('compare-product') ||
              node.querySelector?.('.product-card-item') ||
              node.classList?.contains('col')
            )
          );
          if (hasNewProducts) {
            setTimeout(() => {
              this.syncCheckboxes();
            }, 100);
          }
        }
      });
    });

    const productGrid = document.getElementById('ProductGridContainer');
    if (productGrid) {
      observer.observe(productGrid, {
        childList: true,
        subtree: true
      });
    }

    const mainProductGrid = document.getElementById('product-grid');
    if (mainProductGrid) {
      observer.observe(mainProductGrid, {
        childList: true,
        subtree: true
      });
    }
  }

  saveToStorage() {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(this.compareProducts));
    } catch (e) {
    }
  }

  loadFromStorage() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      if (stored) {
        this.compareProducts = JSON.parse(stored);
        this.compareProducts = this.compareProducts.filter(product => 
          product && product.id && product.title
        );
      }
    } catch (e) {
      this.compareProducts = [];
    }
  }

  saveToggleState(isEnabled) {
    try {
      localStorage.setItem(this.toggleStateKey, JSON.stringify(isEnabled));
    } catch (e) {
    }
  }

  loadToggleState() {
    try {
      const stored = localStorage.getItem(this.toggleStateKey);
      return stored ? JSON.parse(stored) : false;
    } catch (e) {
      return false;
    }
  }

  restoreToggleState() {
    const isEnabled = this.loadToggleState();
    const desktopToggle = document.getElementById('compareToggleDesktop');
    const mobileToggle = document.getElementById('compareToggleMobile');
    
    if (desktopToggle) {
      desktopToggle.checked = isEnabled;
    }
    if (mobileToggle) {
      mobileToggle.checked = isEnabled;
    }
    
    this.toggleCompareMode(isEnabled);
  }

  syncToggleStates(isEnabled) {
    const desktopToggle = document.getElementById('compareToggleDesktop');
    const mobileToggle = document.getElementById('compareToggleMobile');
    
    if (desktopToggle) {
      desktopToggle.checked = isEnabled;
    }
    if (mobileToggle) {
      mobileToggle.checked = isEnabled;
    }
  }

  syncCheckboxes() {
    setTimeout(() => {
      const checkboxes = document.querySelectorAll('.compare-product');
      checkboxes.forEach(checkbox => {
        const productId = checkbox.dataset.productId;
        const isSelected = this.compareProducts.some(p => p.id === productId);
        checkbox.checked = isSelected;
      });

      this.restoreToggleState();
      this.updateUI();
    }, 50);
  }

  toggleCompareMode(isEnabled) {
    const checkboxes = document.querySelectorAll('.product-compare-checkbox');
    checkboxes.forEach(checkbox => {
      if (isEnabled) {
        checkbox.classList.add('active');
      } else {
        checkbox.classList.remove('active');
      }
    });

    if (!isEnabled) {
      this.clearAll();
    }
  }

  handleProductSelection(checkbox) {
    const productData = this.getProductData(checkbox);
    
    if (checkbox.checked) {
      if (this.compareProducts.length >= this.maxCompareProducts) {
        checkbox.checked = false;
        const alertMessage = this.translations.maxProductsAlert.replace('{{ count }}', this.maxCompareProducts);
        alert(alertMessage);
        return;
      }
      if (!this.compareProducts.some(p => p.id === productData.id)) {
        this.compareProducts.push(productData);
      }
    } else {
      this.compareProducts = this.compareProducts.filter(p => p.id !== productData.id);
    }

    this.saveToStorage();
    this.updateUI();
  }

  getProductData(checkbox) {
    return {
      id: checkbox.dataset.productId,
      title: checkbox.dataset.productTitle,
      image: checkbox.dataset.productImage,
      price: checkbox.dataset.productPrice,
      originalPrice: checkbox.dataset.productOriginalPrice,
      vendor: checkbox.dataset.productVendor,
      type: checkbox.dataset.productType,
      description: checkbox.dataset.productDescription,
      variants: checkbox.dataset.productOptions || '',
      availability: checkbox.dataset.productAvailability || '',
      url: checkbox.dataset.productUrl || '#'
    };
  }

  updateUI() {
    const compareBar = document.getElementById('compareBar');
    const compareCount = document.getElementById('compareCount');

    if (!compareBar || !compareCount) {
      return;
    }

    // Only show compare bar on collection pages
    const isCollectionPage = window.location.pathname.includes('/collections/');

    if (this.compareProducts.length > 0 && isCollectionPage) {
      compareBar.classList.add('active');
      document.body.classList.add('compare-bar-activated');

      compareCount.textContent = `${this.translations.compareCount} (${this.compareProducts.length}/${this.maxCompareProducts})`;
      this.updatePreview();
    } else {
      compareBar.classList.remove('active');
      document.body.classList.remove('compare-bar-activated');
    }
  }

  updatePreview() {
    const comparePreview = document.getElementById('comparePreview');
    if (!comparePreview) return;
    
    comparePreview.innerHTML = '';

    this.compareProducts.forEach(product => {
      const productItem = document.createElement('div');
      productItem.className = 'compare-product-item';
      productItem.innerHTML = `
        <img src="${product.image}" alt="${product.title}" loading="lazy">
        <button class="remove-btn" data-product-id="${product.id}">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
        </button>
      `;
      comparePreview.appendChild(productItem);
    });

    const remainingSlots = this.maxCompareProducts - this.compareProducts.length;
    for (let i = 0; i < remainingSlots; i++) {
      const emptySlot = document.createElement('div');
      emptySlot.className = 'compare-product-item';
      emptySlot.innerHTML = '<div style="display: flex; align-items: center; justify-content: center; height: 100%; color: #ccc; font-size: 24px;">+</div>';
      comparePreview.appendChild(emptySlot);
    }
  }

  removeProduct(productId) {
    this.compareProducts = this.compareProducts.filter(p => p.id !== productId);

    const checkbox = document.querySelector(`input[data-product-id="${productId}"]`);
    if (checkbox) {
      checkbox.checked = false;
    }

    this.saveToStorage();
    this.updateUI();
  }

  removeProductFromModal(productId) {
    this.compareProducts = this.compareProducts.filter(p => p.id !== productId);

    const checkbox = document.querySelector(`input[data-product-id="${productId}"]`);
    if (checkbox) {
      checkbox.checked = false;
    }

    this.saveToStorage();
    this.updateUI();

    // If less than 1 product left, close the modal
    if (this.compareProducts.length < 1) {
      this.hideCompareModal();
    } else {
      // Regenerate table with remaining products
      this.generateCompareTable();
    }
  }

  clearAll() {
    this.compareProducts = [];
    
    const checkboxes = document.querySelectorAll('.compare-product');
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
    });

    this.saveToStorage();
    this.updateUI();
  }

  showCompareModal(forceOpen = false) {
    // Check if modal is enabled (Product compare section is active)
    const settings = window.productCompareSettings || {};
    if (!forceOpen && settings.modalEnabled === false) {
      return;
    }

    // Allow force open for Theme Editor preview
    if (!forceOpen && this.compareProducts.length < 2) {
      alert(this.translations.minProductsAlert);
      return;
    }

    // If no products but force open (Theme Editor), show demo content
    if (forceOpen && this.compareProducts.length === 0) {
      this.generateDemoTable();
    } else {
      this.generateCompareTable();
    }

    const modal = document.getElementById('compareModal');
    if (modal) {
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  // Generate demo table for Theme Editor preview
  generateDemoTable() {
    const table = document.getElementById('compareTable');
    if (!table) return;

    const settings = window.productCompareSettings || {};
    const fieldsOrder = settings.fieldsOrder || ['price', 'vendor', 'description', 'variants', 'availability'];

    table.innerHTML = '';

    // Demo products for preview (with placeholder images only)
    const demoProducts = [
      {
        title: 'Demo Product 1',
        image: 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_large.png',
        url: '#'
      },
      {
        title: 'Demo Product 2',
        image: 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-2_large.png',
        url: '#'
      }
    ];

    // Header row
    const headerRow = document.createElement('tr');
    headerRow.innerHTML = '<th></th>';
    demoProducts.forEach(product => {
      headerRow.innerHTML += `
        <td class="product-image-cell">
          <img src="${product.image}" alt="${product.title}" loading="lazy" style="max-width:150px;height:auto;">
          <div class="product-title"><h3 class="h6">${product.title}</h3></div>
          <button class="view-details-btn button button--small">${this.translations.viewDetails}</button>
        </td>
      `;
    });
    table.appendChild(headerRow);

    // Generate rows based on fieldsOrder - all fields show "-" for demo
    fieldsOrder.forEach(field => {
      const row = document.createElement('tr');

      switch(field) {
        case 'price':
          row.innerHTML = `<td>${this.translations.price}</td>`;
          demoProducts.forEach(() => {
            row.innerHTML += `<td>-</td>`;
          });
          table.appendChild(row);
          break;

        case 'vendor':
          row.innerHTML = `<td>${this.translations.vendor}</td>`;
          demoProducts.forEach(() => {
            row.innerHTML += `<td>-</td>`;
          });
          table.appendChild(row);
          break;

        case 'type':
          row.innerHTML = `<td>${this.translations.type}</td>`;
          demoProducts.forEach(() => {
            row.innerHTML += `<td>-</td>`;
          });
          table.appendChild(row);
          break;

        case 'description':
          row.innerHTML = `<td>${this.translations.description}</td>`;
          demoProducts.forEach(() => {
            row.innerHTML += `<td>-</td>`;
          });
          table.appendChild(row);
          break;

        case 'variants':
          row.innerHTML = `<td>${this.translations.variants}</td>`;
          demoProducts.forEach(() => {
            row.innerHTML += `<td>-</td>`;
          });
          table.appendChild(row);
          break;

        case 'availability':
          row.innerHTML = `<td>${this.translations.availability}</td>`;
          demoProducts.forEach(() => {
            row.innerHTML += `<td>-</td>`;
          });
          table.appendChild(row);
          break;
      }
    });
  }

  hideCompareModal() {
    const modal = document.getElementById('compareModal');
    if (modal) {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  generateCompareTable() {
    const table = document.getElementById('compareTable');
    if (!table) return;

    const settings = window.productCompareSettings || {};
    const fieldsOrder = settings.fieldsOrder || ['price', 'vendor', 'description', 'variants', 'availability'];

    table.innerHTML = '';

    // Header row with product images and titles
    const headerRow = document.createElement('tr');
    headerRow.innerHTML = '<th></th>';
    this.compareProducts.forEach(product => {
      headerRow.innerHTML += `
        <td class="product-image-cell">
          <button class="compare-modal-remove-btn" data-product-id="${product.id}" title="Remove from compare">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
          </button>
          <img src="${product.image}" alt="${product.title}" loading="lazy">
          <div class="product-title"><h3 class="h6">${product.title}</h3></div>
          <button class="view-details-btn button button--small" onclick="window.location.href='${product.url}'">${this.translations.viewDetails}</button>
        </td>
      `;
    });
    table.appendChild(headerRow);

    // Generate rows based on fieldsOrder (respects block drag order)
    fieldsOrder.forEach(field => {
      const row = document.createElement('tr');

      switch(field) {
        case 'price':
          row.innerHTML = `<td>${this.translations.price}</td>`;
          this.compareProducts.forEach(product => {
            const priceHtml = this.getFormattedPrice(product.price, product.originalPrice);
            row.innerHTML += `<td>${priceHtml}</td>`;
          });
          table.appendChild(row);
          break;

        case 'vendor':
          row.innerHTML = `<td>${this.translations.vendor}</td>`;
          this.compareProducts.forEach(product => {
            row.innerHTML += `<td>${product.vendor || '-'}</td>`;
          });
          table.appendChild(row);
          break;

        case 'type':
          row.innerHTML = `<td>${this.translations.type}</td>`;
          this.compareProducts.forEach(product => {
            row.innerHTML += `<td>${product.type || '-'}</td>`;
          });
          table.appendChild(row);
          break;

        case 'description':
          row.innerHTML = `<td>${this.translations.description}</td>`;
          this.compareProducts.forEach(product => {
            row.innerHTML += `<td>${product.description || '-'}</td>`;
          });
          table.appendChild(row);
          break;

        case 'variants':
          row.innerHTML = `<td>${this.translations.variants}</td>`;
          this.compareProducts.forEach(product => {
            const shouldShowDash = !product.variants ||
                                  product.variants.trim() === '' ||
                                  product.variants === 'Title: Default Title' ||
                                  product.variants.includes('Title: Default Title');

            if (shouldShowDash) {
              row.innerHTML += '<td>-</td>';
            } else {
              let variantHtml = '<div class="variants-container-formatted">';

              if (product.variants.includes(';')) {
                const options = product.variants.split(';');
                let hasValidOptions = false;

                options.forEach(option => {
                  const parts = option.split(':');
                  if (parts.length === 2) {
                    const optionName = parts[0].trim();
                    const values = parts[1].trim();
                    if (optionName && values && values !== 'Default Title' && optionName !== 'Title') {
                      hasValidOptions = true;
                      variantHtml += `
                        <div class="variant-option-line">
                          <strong>${optionName}:</strong> ${values}
                        </div>
                      `;
                    }
                  }
                });

                variantHtml += '</div>';
                row.innerHTML += hasValidOptions ? `<td>${variantHtml}</td>` : '<td>-</td>';
              } else {
                row.innerHTML += '<td>-</td>';
              }
            }
          });
          table.appendChild(row);
          break;

        case 'availability':
          row.innerHTML = `<td>${this.translations.availability}</td>`;
          this.compareProducts.forEach(product => {
            const isAvailable = product.availability === 'true';
            const availabilityText = isAvailable ? this.translations.inStock : this.translations.outOfStock;
            const availabilityClass = isAvailable ? 'product-available' : 'product-unavailable';
            row.innerHTML += `<td><span class="${availabilityClass}">${availabilityText}</span></td>`;
          });
          table.appendChild(row);
          break;
      }
    });
  }

  refresh() {
    this.syncCheckboxes();
    this.restoreToggleState();
    this.updateUI();
  }

  destroy() {
    const existingBar = document.getElementById('compareBar');
    const existingModal = document.getElementById('compareModal');
    
    if (existingBar) existingBar.remove();
    if (existingModal) existingModal.remove();
  }

  isCompareEnabled() {
    return this.loadToggleState();
  }
}
} // End of if (typeof ProductCompare === 'undefined')

function initProductCompare() {
  if (window.productCompare) {
    window.productCompare.destroy();
  }

  window.productCompare = new window.ProductCompare();
}

document.addEventListener('DOMContentLoaded', initProductCompare);
setTimeout(initProductCompare, 1000);

document.addEventListener('shopify:section:load', function() {
  setTimeout(initProductCompare, 300);
});

window.refreshProductCompare = function() {
  if (window.productCompare) {
    window.productCompare.refresh();
  }
};

window.testCompareSettings = function() {
  if (window.productCompare) {
    window.productCompare.generateCompareTable();
  }
};